import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import globalComponents from "./plugins/globalComponents";
Vue.use(globalComponents);

import Toasted from "vue-toasted";
Vue.use(Toasted);

// import "./registerServiceWorker";

import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

import Sticky from "vue-sticky-directive";
Vue.use(Sticky);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.config.productionTip = false;

import { projectAuth } from "@/firebase/config";

let app;

projectAuth.onAuthStateChanged(() => {
  console.log("got user");
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }
});
